import * as Sentry from '@sentry/react';
import { useMutation } from 'react-query';
import { client } from '@/util/client';

type PatientFeedback = {
  rating: number;
  maxScore: number;
  questionnaireId: string;
};

export const useSavePatientFeedback = () => {
  return useMutation<unknown, Error, PatientFeedback>({
    mutationFn: async (data) => {
      const response = await client.post('/patient-feedback/createFeedback', {
        rating: data.rating,
        maxScore: data.maxScore,
        questionnaireId: data.questionnaireId,
      });
      return response.data;
    },
    onError: (error) => {
      Sentry.captureException(error, {
        tags: { feature: 'patient-feedback' },
        fingerprint: ['patient-feedback-save-failed'],
      });
    },
  });
};
